import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6be07ea8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp64\\www\\smmmile-quiz\\node_modules\\vue-loader\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be07ea8')) {
      api.createRecord('6be07ea8', component.options)
    } else {
      api.reload('6be07ea8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6be07ea8&", function () {
      api.rerender('6be07ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quiz/index.vue"
export default component.exports